import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.PageContent.RequestVersionHistory.EmptyVersionHistoryList', {
    emptyListText: 'There are no request details versions',
});
